import React, { useState,useEffect } from "react";
import PropTypes from "prop-types";
import { useAuth } from "../../context/AuthContext";
import { useHistory } from 'react-router-dom';
import api from "../../api/api";
import { useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import EditEmployer from "../EditEmployer";

const BasicInfoEmployer = () => {

  const {t} = useTranslation();
  const { user } = useAuth();
  const history = useHistory();
  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  
  const { id: employerId } = useParams();

  const [loadingDetails, setLoadingDetails] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const fetchData = async () => {
  
    setLoadingDetails(true)
    setError(null)

    try {
      let typeurl;
    
      typeurl=`/employer-management/${employerId}/profile`
      
     

      const response = await api.get(typeurl, {
        params: { id: employerId }
      });
  
      setData(response.data.employer_details)
    } catch (error) {
      console.log( error);
      
      setError(error.response.data.error)
      console.log("Response Code:", error.response.data.error);
    } finally {
      setLoadingDetails(false);
    }
  }

  console.log(data);
  

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(()=>{
    fetchData()
  },[])
    
  return (
    <>
        {
          (loadingDetails || error) ? (
            <div style={{ textAlign: "center", margin: "10em" }}>
              {loadingDetails && (
                <div>
                  <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em", color: "#007bff" }} />
                  <p className="mt-3 text-muted">{t("Loading employer information...")}</p>
                </div>
              )}
              {error && (
                <div className="alert alert-danger alert-dismissible fade show shadow-sm" role="alert">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-exclamation-circle me-2"></i>
                    <div>
                      <strong>{t("Error!")}</strong> {error}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="container pt-4">
              {/* Header with Back Button */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="d-flex align-items-center">
                  
                  <div>
                    <h4 className="mb-0 text-primary">{t("Basic Employer Information")}</h4>
                    <p className="text-muted small mb-0">{t("View and manage employer details")}</p>
                  </div>
                </div>
                
                  <button 
                  className="btn btn-outline-secondary" 
                  onClick={() => {
                    
                    //if (window.history.length > 1) {
                     // history.goBack();
                    //} else {
                      history.push('/employer-management'); // fallback route
                    //}
                  }}
                  style={{
                    borderRadius: '8px',
                    padding: '10px 20px',
                    fontWeight: '600'
                  }}
                >
                  <i className="fas fa-arrow-left me-2"></i>
                  {t("Back")}
                </button>
              </div>
               
              {/* Styled Form Card */}
              <div className="card shadow-sm" style={{ borderRadius: '12px', border: '1px solid #e9ecef' }}>
                <div className="card-header bg-light" style={{ borderRadius: '12px 12px 0 0', padding: '20px' }}>
                  <div className="d-flex align-items-center">
                    <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px' }}>
                      <i className="fas fa-user text-white"></i>
                    </div>
                    <div>
                      <h5 className="mb-0 text-dark">{t("Employer Details")}</h5>
                      <small className="text-muted">{t("Basic information and contact details")}</small>
                    </div>
                  </div>
                </div>
                <div className="card-body" style={{ paddingTop: '30px' }}>
                  <div className="row">
                    <div className="col-lg-8 col-md-10">
                      <div className="row g-4">
                        {/* Title Field */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark mb-2">
                              <i className="fas fa-user-tag me-2 text-primary"></i>
                              { t("Title") }
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              defaultValue={data.title || "Not provided"}
                              readOnly
                              style={{
                                backgroundColor: '#f8f9fa',
                                border: '2px solid #e9ecef',
                                borderRadius: '8px',
                                padding: '12px 16px',
                                fontSize: '14px'
                              }}
                            />
                          </div>
                        </div>

                        {/* Name Field */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark mb-2">
                              <i className="fas fa-user me-2 text-primary"></i>
                              {t("Name")} *
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              defaultValue={data.name || "Not provided"}
                              readOnly
                              style={{
                                backgroundColor: '#f8f9fa',
                                border: '2px solid #e9ecef',
                                borderRadius: '8px',
                                padding: '12px 16px',
                                fontSize: '14px',
                                fontWeight: '500'
                              }}
                            />
                          </div>
                        </div>

                        {/* Email Field */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark mb-2">
                              <i className="fas fa-envelope me-2 text-primary"></i>
                              {t("Email Address")}
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              defaultValue={data.email || "Not provided"}
                              readOnly
                              style={{
                                backgroundColor: '#f8f9fa',
                                border: '2px solid #e9ecef',
                                borderRadius: '8px',
                                padding: '12px 16px',
                                fontSize: '14px'
                              }}
                            />
                          </div>
                        </div>

                        {/* Contact Field */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark mb-2">
                              <i className="fas fa-phone me-2 text-primary"></i>
                              {t("Contact Number")}
                            </label>
                            <input
                              className="form-control"
                              type="tel"
                              defaultValue={data.phone || "Not provided"}
                              readOnly
                              style={{
                                backgroundColor: '#f8f9fa',
                                border: '2px solid #e9ecef',
                                borderRadius: '8px',
                                padding: '12px 16px',
                                fontSize: '14px'
                              }}
                            />
                          </div>
                        </div>
<button 
                  className="btn btn-primary shadow-sm me-2 mt-3" 
                  data-bs-toggle="modal" 
                  data-bs-target="#edit_employer"
                  style={{
                    borderRadius: '8px',
                    padding: '10px 20px',
                    maxWidth: '200px',
                    fontWeight: '600',
                    boxShadow: '0 2px 4px rgba(0,123,255,0.2)'
                  }}
                >
                  <i className="fas fa-edit me-2"></i>
                  {t("Edit")}
                </button>
                        {/* Created Date */}
                        {data.created_at && (
                          <div className="col-12">
                            <div className="bg-light p-3 rounded-3 mt-3">
                              <small className="text-muted">
                                <i className="fas fa-calendar-alt me-2"></i>
                               {t("Created on")}: {new Date(data.created_at).toLocaleDateString('en-US', {
                                  year: 'numeric',
                                  month: 'long',
                                  day: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit'
                                })}
                              </small>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

      <EditEmployer onRefresh={()=>fetchData()} selectedEmployer={data} />
    </>
  );
}

BasicInfoEmployer.propTypes = {
  user: PropTypes.shape({
      company: PropTypes.string,
      name: PropTypes.string,
      email: PropTypes.string,
  }).isRequired,
};

export default BasicInfoEmployer;      